import React from "react";
import { isEmpty, map } from "lodash";
import { useNavigate } from "react-router-dom";
import playlistStore from "../../zustand/playlist.store";
import MobileHeader from "../components/MobileHeader";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import ThumbNail from "../../components/thumbNail/ThumbNail";
import styles from "./MobileSchedule.module.scss";

const DAYS_MAP = { 0: "Sun", 1: "Mon", 2: "Tue", 3: "Wed", 4: "Thu", 5: "Fri", 6: "Sat" };

const MobileSchedule = () => {
  const { playlists, isLoading } = playlistStore();
  const navigate = useNavigate();

  const schedules = [];
  if (playlists) {
    playlists.forEach((pl) => {
      if (pl.schedule) {
        pl.schedule.forEach((sch, idx) => {
          schedules.push({ ...sch, playlistName: pl.name, playlistId: pl.id, color: pl.color, image: pl.image, scheduleIndex: idx });
        });
      }
    });
  }

  const handleEdit = (plId) => navigate(`/mobile/schedule/${plId}/edit`);

  const rightAction = (
    <button className={styles.addBtn} onClick={() => navigate("/mobile/schedule/create")}>
      <Icons type={ICONS.PLUS} />
    </button>
  );

  return (
    <div className={styles.page}>
      <MobileHeader title="My Schedules" rightAction={rightAction} />
      {isLoading ? (
        <div className={styles.loader}>Loading...</div>
      ) : isEmpty(schedules) ? (
        <div className={styles.empty}>
          <p>No schedules yet</p>
          <p className={styles.emptyHint}>Tap the clock icon on a playlist to create a schedule</p>
          <button className={styles.createBtn} onClick={() => navigate("/mobile/playlists")}>Go to Playlists</button>
        </div>
      ) : (
        <div className={styles.list}>
          {map(schedules, (sch, i) => (
            <div key={sch.id || i} className={styles.item} onClick={() => handleEdit(sch.playlistId)}>
              <div className={styles.thumb}>
                <ThumbNail name={sch.playlistName} color={sch.color} hasImage={!!sch.image} />
              </div>
              <div className={styles.info}>
                <p className={styles.name}>{sch.playlistName}</p>
                <p className={styles.time}>{sch.time}</p>
                <div className={styles.days}>
                  {sch.days?.map((d) => <span key={d} className={styles.day}>{DAYS_MAP[d]}</span>)}
                </div>
              </div>
              <div className={styles.arrow}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="#949494" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileSchedule;
